module.exports = "<div id=\"{{ $ctrl.elementModel.sectionId }}\">\n    <div class=\"image-placeholder\">\n        <em class=\"fa fa-code\"></em>\n    </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/cmsCore/Creator/SectionsLibrary/Sections/Page/Html/html.html
// module id = 1144
// module chunks = 0